const svgString = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 32' width='24' height='32'>
  <path fill='red' stroke='darkred' stroke-width='0.5' d='M12 2C7.5 2 4 5.5 4 10c0 6 6.5 12 7.5 18a1 1 0 0 0 1 0c1-6 7.5-12 7.5-18 0-4.5-3.5-8-8-8z'/>
  <circle cx='12' cy='10' r='3.5' fill='darkred' stroke='darkred' stroke-width='1'/>
</svg>`;
export const pinDataUrl = "data:image/svg+xml;utf8," + encodeURIComponent(svgString);
